import { connect } from 'formik';
import React, { Component, PropsWithChildren } from 'react';
import { Overwrite } from 'utility-types';
import { resolveProps } from '../utils/formikUtils';
import { BaseSelector } from './BaseSelector';
import { InnerSelectorProps, ISelectorAsset, ISelectorProps, ISelectorWithContextProps } from './types';

export class Selector extends Component<PropsWithChildren<InnerSelectorProps>, {}> {
  public componentDidMount() {
    this.props.formik.registerField && this.props.formik.registerField(this.props.name, this);
  }

  public componentWillUnmount() {
    this.props.formik.unregisterField && this.props.formik.unregisterField(this.props.name);
  }
  public render() {
    const { value = [], valid = true, touched = false, onBlur } = resolveProps(this.props, this.props.formik);
    return (
      <BaseSelector
        {...this.props}
        value={value}
        valid={valid}
        touched={touched}
        onChange={this.handleChange}
        onBlur={onBlur}
      />
    );
  }

  private handleChange = (selected: ISelectorAsset[]) => {
    const { formik } = this.props;
    if (this.props.onChange) {
      this.props.onChange(selected);
    } else if (formik && formik.setFieldValue) {
      formik.setFieldValue(this.props.name, selected);
    }
  };
}

export default connect<Overwrite<ISelectorProps, ISelectorWithContextProps>>(Selector);
